export default __webpack_public_path__ + "static/media/vEth.24e4512f.svg";